import * as React from 'react';
import type { IconProps } from './types';

interface VizitLogoProps extends IconProps {
  /**
   * The height of the icon.
   *
   * @optional
   * @type string | number
   * @default 34
   */
  height?: string | number;
  /**
   * The width of the icon.
   *
   * @optional
   * @type string | number
   * @default 132
   */
  width?: string | number;
}

export const VizitLogo = React.forwardRef<SVGSVGElement, VizitLogoProps>((props, forwardedRef) => {
  const { color = 'currentColor', height = 34, width = 132, ...other } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 132 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...other}
      ref={forwardedRef}
    >
      <path d="M45.5736 0H39.8381V33.7061H45.5736V0Z" fill={color} />
      <path
        d="M57.6452 0V5.64935H72.9882L57.2725 27.1714L57.1482 33.7061H79.7798V27.9303H63.6085L79.7798 5.64935V0H57.6452Z"
        fill={color}
      />
      <path d="M104.896 0V5.64935H115.415V33.7061H121.088V0H104.896Z" fill={color} />
      <path d="M126.389 0V5.61768H132V0H126.389Z" fill={color} />
      <path d="M96.303 0H90.5675V33.7061H96.303V0Z" fill={color} />
      <path d="M24.8678 0L15.4466 30.7549L6.04612 0H0L10.1252 33.7061H20.768L30.9139 0H24.8678Z" fill={color} />
    </svg>
  );
});
